import { APP_ENVIRONMENT } from "config";
import { getCookies } from "cookies-next";
import * as deviceObj from "react-device-detect";
import americanExpImg from "../public/assets/images/cards/american-exp.svg";
import dinersClubImg from "../public/assets/images/cards/diners-club.svg";
import discoverImg from "../public/assets/images/cards/discover.svg";
import jcbImg from "../public/assets/images/cards/jcb.svg";
import mastercardImg from "../public/assets/images/cards/mastercard.svg";
import unionPayImg from "../public/assets/images/cards/union-pay.svg";
import visaImg from "../public/assets/images/cards/visa.svg";
import store from "../store";
import {
  clearVehicleList,
  getBrandList,
  getCategoryList,
  getCmsList,
  getDynamicPageList,
  getLocations,
  getVehicleFilterData,
  setCurrentLocationId,
  setVehicleList,
  setVehicleMetaData,
} from "../store/actions";
import {
  get_cookie,
  replaceSpaceWithHypenToLowercase,
  set_cookie,
  strToLowerCase,
} from "./functions";

/*******************
@purpose : get location from slug and location arr
@Parameter : {locationArr,slug}
@Author : INIC
******************/
export const getLocationFromSlugUsingLocationArr = (
  locationArr,
  slug,
  slug2
) => {
  let matchLocation = "";

  locationArr.forEach(function (location) {
    const stateShortName = strToLowerCase(location.state_short_name);
    const citySlug = strToLowerCase(location.city_slug);
    if (slug === stateShortName && slug2 === citySlug) {
      matchLocation = location;
    }
  });

  return matchLocation;
};

/*******************
@purpose : get location from slug and location arr
@Parameter : {locationArr,slug}
@Author : INIC
******************/
export const getLocationFromSlugUsingLocationArrOneSlug = (
  locationArr,
  slug
) => {
  let matchLocation = "";
  locationArr.forEach(function (location) {
    const stateShortName = strToLowerCase(location.state_short_name);
    if (slug === stateShortName) {
      matchLocation = location;
    }
  });
  return matchLocation;
};

/*******************
@purpose : check slug2 is location or not
@Parameter : {locationArr,slug}
@Author : INIC
******************/
export const checkSlugIsLocation = (locationArr, slug1, slug2) => {
  let matchLocation = "";

  locationArr.forEach(function (location) {
    const stateShortName = strToLowerCase(location.state_short_name);
    const city_slug = strToLowerCase(location.city_slug);
    if (slug1 == stateShortName && slug2 == city_slug) {
      matchLocation = location;
    }
  });
  return matchLocation;
};

/*******************
@purpose : default location options
@Author : INIC
******************/
export const locationOptions = () => {
  const options = [
    {
      value: "Los Angeles",
      label: "LA",
      instanceId: "l1",
      id: "l1",
      inputId: "l1",
    },
    {
      value: "Miami",
      label: "Miami",
      instanceId: "l2",
      id: "l2",
      inputId: "l2",
    },
  ];
  return options;
};

/*******************
@purpose : get locations options from location arr
@Parameter : {locations}
@Author : INIC
******************/
export const getSelectLocationsOptions = (
  locations,
  currentLocationId,
  flag
) => {
  let options = [];
  let optionValue = "";
  let index = 0;
  let defaultOptionValue = "0";
  let checkCityStateSlug = "";

  if (locations?.data) {
  } else {
    if (get_cookie("cityStateSlug")) {
      checkCityStateSlug = get_cookie("cityStateSlug");
    }

    locations?.forEach(function (location, currentElementIndex) {
      if (checkCityStateSlug) {
        const tempCitySlug = makeCityStateSlugUsingLocation(location);
        if (tempCitySlug === checkCityStateSlug) {
          // defaultOptionValue = index;
          defaultOptionValue = currentElementIndex;
          set_cookie("selectedCityName", location.city_name, 100000);
        }
      }

      if (currentElementIndex === 0) {
        optionValue = "/";
      } else {
        optionValue =
          strToLowerCase(location.state_short_name) +
          "/" +
          replaceSpaceWithHypenToLowercase(location.city_slug);
      }

      let labelValue = "";
      if (flag !== "footer") {
        labelValue = location.city_name;
      } else {
        if (location.city_short_name === "miami") {
          // labelValue = location.city_short_name.toUpperCase();
          labelValue =
            location.city_short_name[0].toUpperCase() +
            location.city_short_name.slice(1);
        } else {
          labelValue = location.city_short_name.toUpperCase();
        }
      }

      let object = {
        value: optionValue,
        label: labelValue,
        id: location.id,
      };

      options.push(object);
      index++;
    });
  }
  return {
    defaultOptionValue,
    options,
  };
};

/*******************
@purpose : Call common api header footer
@Parameter : {}
@Author : INIC
******************/
export const headerFooterApi = (flag = "all") => {
  // Fetch all header and footer api here
  store.dispatch(getLocations()).then((res) => {
    if (res && res.length > 0) {
      let id = "";
      const tempLocationId = get_cookie("currentLocationId");
      if (tempLocationId) {
        id = tempLocationId;
      } else {
        id = res[0]["id"];
        setCurrentLocationIdInCookie(id);
        const cityStateSlug = makeCityStateSlugUsingLocation(res["0"]);
        setCityStateSlugInCookie(cityStateSlug);
      }

      // set current locations
      store.dispatch(setCurrentLocationId(id));
      // brand list
      store.dispatch(getBrandList(id));
      // category list
      store.dispatch(getCategoryList(id));

      if (flag != "login" && flag != "profile") {
        // get dynamic page list
        store.dispatch(getDynamicPageList(id));
        // get cms  list
        store.dispatch(getCmsList(id));
      }
    }
  });
};

/*******************
  @purpose : Email Validation
  @Parameter : {value}
  @Author : INIC
  ******************/
export const emailValidation = (value) => {
  if (/\S+@\S+\.\S+/.test(value)) {
    return true;
  }
  return false;
};

/*******************
  @purpose : Only Spaces and letter allowed
  @Parameter : {value}
  @Author : INIC
  ******************/
export const nameValidation = (value) => {
  let reg = /^[a-zA-Z\s]*$/;
  if (reg.test(value)) {
    return true;
  }
  return false;
};

/*******************
  @purpose : set current location id in cookie
  @Parameter : {currentLocationId}
  @Author : INIC
  ******************/
export const setCurrentLocationIdInCookie = (currentLocationId) => {
  set_cookie("currentLocationId", currentLocationId, 1);
};

/*******************
  @purpose : calculate age
  @Parameter : {dob}
  @Author : INIC
  ******************/
export const calculate_age = (dob) => {
  var diff_ms = Date.now() - new Date(dob).getTime();
  var age_dt = new Date(diff_ms);
  var age = Math.abs(age_dt.getUTCFullYear() - 1970);
  return age;
};

/*******************
  @purpose : first letter capital
  @Parameter : {str}
  @Author : INIC
  ******************/
export const capitalizeFirstLetter = (string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

/*******************
  @purpose : format money as per americal standard
  @Parameter : {money}
  @Author : INIC
  ******************/
export const formatMoney = (money) => {
  // return parseFloat(money)
  //   ?.toFixed(2)
  //   .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return money?.toLocaleString();
};

/*******************
  @purpose : format money as per americal standard without two tofixed(2) e.g $1000=>$1,000
  @Parameter : {money}
  @Author : INIC
  ******************/
export const formatMoneyLocalString = (money) => {
  return money?.toLocaleString();
};

/*******************
@purpose : get payment card brand logos according to name
@Parameter : {card name}
@Author : INIC
******************/
export const getCardImages = (cardName) => {
  let selectCardImage = "";
  switch (cardName) {
    case "visa":
      selectCardImage = visaImg;
      break;
    case "mastercard":
      selectCardImage = mastercardImg;
      break;
    case "amex":
      selectCardImage = americanExpImg;
      break;
    case "discover":
      selectCardImage = discoverImg;
      break;
    case "diners":
      selectCardImage = dinersClubImg;
      break;
    case "jcb":
      selectCardImage = jcbImg;
      break;
    case "unionpay":
      selectCardImage = unionPayImg;
      break;
    default:
      selectCardImage = "";
      break;
  }
  return selectCardImage;
};

/*******************
  @Purpose : Used to hrefUrl
  @Parameter : {value}
  @Author : INIC
 *******************/
export const hrefURL = (value) => {
  const r = get_cookie("redirectUrl");
  const dUrl = "/ca/los-angeles";
  let path = "";
  if (r) {
    if (r === "/") {
      path = dUrl + "/" + value;
    } else {
      path = r + "/" + value;
    }
  } else {
    path = dUrl + "/" + value;
  }
  return path;
};

/********************
  @purpose : Set cityStateSlug in cookie
  @Parameter : {cityStateSlug}
  @Author : INIC
  ******************/
export const setCityStateSlugInCookie = (cityStateSlug) => {
  set_cookie("cityStateSlug", cityStateSlug);
};

/********************
  @purpose : Make  city State Slug using location
  @Parameter : {location}
  @Author : INIC
  ******************/
export const makeCityStateSlugUsingLocation = (location) => {
  return strToLowerCase(
    location["city_short_name"] + "_" + location["state_short_name"]
  );
};

/*******************
@purpose : get location id using cityStateSlug
@Parameter : {locations,cityStateSlug}
@Author : INIC
******************/
export const getLocationIdUsingCityStateSlug = (locationArr, cityStateSlug) => {
  let matchLocation = "";
  locationArr.forEach(function (location) {
    const checkSlug = makeCityStateSlugUsingLocation(location);
    if (checkSlug === cityStateSlug) {
      matchLocation = location;
    }
  });
  return matchLocation ? matchLocation.id : "";
};

/*******************
@purpose : set default Redirect url
@Parameter : {locations}
@Author : INIC
******************/
export const setDefaultRedirectUrlUsingLocations = (
  locationArr,
  currentLocationId
) => {
  let defaultRedirectURL = "/";

  if (locationArr && locationArr.length > 0) {
    locationArr.forEach(function (location, index) {
      if (location.id == currentLocationId) {
        if (index == 0) {
          defaultRedirectURL = "/";
        } else {
          defaultRedirectURL =
            "/" +
            strToLowerCase(location.state_short_name) +
            "/" +
            replaceSpaceWithHypenToLowercase(location.city_slug);
        }
      }
    });
  }
  set_cookie("redirectUrl", defaultRedirectURL, 1);
};

/*******************
@purpose : Clear cookie value
@Parameter : {}
@Author : INIC
******************/
export const clearTimeDateCookieValue = () => {
  set_cookie("brandId", "");
  set_cookie("vId", "");
  set_cookie("vSlug", "");
  set_cookie("daterange", "");
  set_cookie("timerange", "");
  set_cookie("month_range", "")
};

/*******************
@purpose : Check device is iphone
@Parameter : {}
@Author : INIC
******************/
export const getFadeFlag = () => {
  let flag = false;
  if (
    deviceObj.isMobile &&
    deviceObj.isIOS &&
    (deviceObj.isChrome || deviceObj.isChromium)
  ) {
    flag = true;
  }
  return flag;
};
/*******************
@purpose : Used for decode html entities
@Parameter : {}
@Author : INIC
******************/
export const decodeHtml = (string) => {
  if (typeof window !== "undefined") {
    const html = document.createElement("textarea");

    html.innerHTML = string;

    return html.value;
  }
  return "";
};

export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export function decodeEntities(encodedString) {
  var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
  var translate = {
    nbsp: " ",
    amp: "&",
    quot: '"',
    lt: "<",
    gt: ">",
  };
  return encodedString
    .replace(translate_re, function (match, entity) {
      return translate[entity];
    })
    .replace(/&#(\d+);/gi, function (match, numStr) {
      var num = parseInt(numStr, 10);
      return String.fromCharCode(num);
    });
}

export function removeItemFromArr(arr, itemValue) {
  return arr.filter(function (item) {
    return item !== itemValue;
  });
}

/*******************
  @purpose : get category str for api
  @Parameter : {}
  @Author : INIC
  ******************/
export function getCategoryStrFromArr(list) {
  let categoryStr = "";
  if (list.length > 0) {
    list.forEach(function (value, index) {
      if (index) {
        categoryStr = categoryStr + "&" + "category_slug[]=" + value;
      } else {
        categoryStr = "category_slug[]=" + value;
      }
    });
  }
  return categoryStr;
}

/*******************
  @purpose : get Brand str for api
  @Parameter : {}
  @Author : INIC
  ******************/
export function getBrandStrFromArr(list) {
  let brandStr = "";
  if (list.length > 0) {
    list.forEach(function (value, index) {
      if (index) {
        brandStr = brandStr + "&" + "brand_slug[]=" + value;
      } else {
        brandStr = "brand_slug[]=" + value;
      }
    });
  }
  return brandStr;
}

/*******************
  @purpose : get Color str for api
  @Parameter : {}
  @Author : INIC
  ******************/
export function getColorStrFromArr(list) {
  let colorStr = "";
  if (list.length > 0) {
    list.forEach(function (value, index) {
      if (index) {
        colorStr = colorStr + "&" + "color_id[]=" + value;
      } else {
        colorStr = "color_id[]=" + value;
      }
    });
  }
  return colorStr;
}

/*******************
  @purpose : Call vehicle api using state value
  @Parameter : {}
  @Author : INIC
  ******************/
export function callVehicleApiForFilterOption() {
  let brandStr = "";
  let categoryStr = "";
  let colorStr = "";
  let maxPrice = "";
  let slug3 = store.getState().common.selectedSlug;
  let selectedPage = store.getState().common.selectedPage;
  let selectedSeat = store.getState().common.selectedSeat;

  if (selectedPage != "category") {
    categoryStr = getCategoryStrFromArr(
      store.getState().common.categorySlugArr
    );
  } else {
    brandStr = getBrandStrFromArr(store.getState().common.brandSlugArr);
  }
  colorStr = getColorStrFromArr(store.getState().common.colorArr);

  if (store.getState().common.selectedPrice) {
    maxPrice = store.getState().common.selectedPrice - 1;
  }

  store
    .dispatch(
      getVehicleFilterData(
        get_cookie("currentLocationId"),
        slug3,
        categoryStr,
        colorStr,
        0,
        maxPrice,
        selectedSeat,
        "",
        brandStr,
        selectedPage
      )
    )
    .then((res) => {
      store.dispatch(clearVehicleList(""));
      store.dispatch(setVehicleList(res?.data));
      store.dispatch(setVehicleMetaData(res));

      if (selectedPage == "brand" || selectedPage == "category") {
        // document?.getElementById("brand-list")?.scrollIntoView();

        if (Math.abs(document.body.getBoundingClientRect().y) >= 549) {
          document?.getElementById("brand-list")?.scrollIntoView();
        }
      }
    });
}

/*******************
  @purpose : Recent search logic
  @Parameter : {data}
  @Author : INIC
  ******************/
export function setRecentSearch(data) {
  let arrOfObj = [];
  const storageKeyName = makeLocalStorageKey("v2_recentSearch");
  const recentSearchData = get_cookie(storageKeyName);
  if (typeof recentSearchData !== "undefined") {
    if (recentSearchData) {
      const tempOfObj = JSON.parse(recentSearchData);
      arrOfObj = [...tempOfObj].reverse();
    }
  }
  const recentSearchObj = {
    label: data.label,
    image: data.image,
    slugUrl: data.slugUrl,
    type: data.type,
  };
  arrOfObj.push(recentSearchObj);

  const reverseArr = [...arrOfObj].reverse();
  // Creates an array of objects with unique "name" property values.
  let uniqueObjArray = [
    ...new Map(reverseArr.map((item) => [item["label"], item])).values(),
  ];

  let recentSearch = "";
  if (uniqueObjArray.length > 10) {
    const start_index = uniqueObjArray.length - 11;
    let last10Result = uniqueObjArray.slice(start_index, 10);
    recentSearch = JSON.stringify(last10Result);
  } else {
    recentSearch = JSON.stringify(uniqueObjArray);
  }
  set_cookie(storageKeyName, recentSearch);
}

/*******************
  @purpose : get Recent search logic
  @Parameter : {data}
  @Author : INIC
  ******************/
export function getRecentSearchList() {
  const url = new URL(window.location.href);
  let arrOfObj = [];
  let tempRecentSearchOptions = [];

  /*
  let storageKeyName = "v1_recentSearch_la_ca";
  if (url.pathname != "/") {
    if (url.pathname.includes("/ca")) {
      storageKeyName = "v1_recentSearch_la_ca";
    } else {
      storageKeyName = "v1_recentSearch_miami_fl";
    }
  }*/

  let storageKeyName = makeLocalStorageKey("v2_recentSearch");
  const recentSearchData = get_cookie(storageKeyName);

  if (typeof recentSearchData !== "undefined") {
    if (recentSearchData) {
      arrOfObj = JSON.parse(recentSearchData);

      arrOfObj.forEach(function (row) {
        const obj = {
          label: row.label,
          image: row.image,
          slugUrl: row.slugUrl,
          type: row.type,
        };
        tempRecentSearchOptions.push(obj);
      });
    }
  }
  return tempRecentSearchOptions;
}

/*******************
  @purpose : Set recently view vehicles
  @Parameter : {data}
  @Author : INIC
  ******************/
export function setRecentlyViewVehicles(data) {
  let arrOfObj = [];
  // const storageKeyName = "v1_recently_viewed_" + get_cookie("cityStateSlug");
  let storageKeyName = makeLocalStorageKey("v2_recently_viewed");
  const list = localStorage.getItem(storageKeyName);
  if (typeof list !== "undefined") {
    if (list) {
      const tempOfObj = JSON.parse(list);
      arrOfObj = [...tempOfObj].reverse();
    }
  }
  let slugUrl = hrefURL(
    data?.brand_detail?.slug +
    "/" +
    data?.category_detail?.slug +
    "/" +
    data?.slug +
    "/" +
    data?.slug_id
  );

  const obj = {
    mainImage: data.all_images["0"].image.main,
    slugUrl: slugUrl,
    brandName: data?.brand_detail?.title,
    vehicleName: data?.name,
    real_price: data?.real_price,
    day: data?.day,
    slug_id: data?.slug_id,
  };
  arrOfObj.push(obj);

  const reverseArr = [...arrOfObj].reverse();
  // Creates an array of objects with unique "name" property values.
  let uniqueObjArray = [
    ...new Map(reverseArr.map((item) => [item["slugUrl"], item])).values(),
  ];

  let recentlyViewedStr = "";
  let recentlyViewedStrCookie = "";
  if (uniqueObjArray.length > 10) {
    const start_index = uniqueObjArray.length - 11;
    let last10Result = uniqueObjArray.slice(start_index, 10);
    recentlyViewedStr = JSON.stringify(last10Result);
    recentlyViewedStrCookie = last10Result.map((data) => data.slug_id);
  } else {
    recentlyViewedStr = JSON.stringify(uniqueObjArray);
    recentlyViewedStrCookie = uniqueObjArray.map((data) => data.slug_id);
  }
  localStorage.setItem(storageKeyName, recentlyViewedStr);
  set_cookie(storageKeyName, JSON.stringify(recentlyViewedStrCookie));
}

/*******************
  @purpose : get Recently viewed 
  @Parameter : {data}
  @Author : INIC
  ******************/
export function getRecentlyViewedList() {
  let recentlyViewedVehicleArr = [];
  // const storageKeyName = "v1_recently_viewed_" + get_cookie("cityStateSlug");
  let storageKeyName = makeLocalStorageKey("v2_recently_viewed");
  const list = localStorage.getItem(storageKeyName);
  if (typeof list !== "undefined") {
    if (list) {
      const tempOfObj = JSON.parse(list);
      recentlyViewedVehicleArr = [...tempOfObj];
    }
  }
  return recentlyViewedVehicleArr;
}

/*******************
  @purpose : get Recently viewed 
  @Parameter : {data}
  @Author : INIC
  ******************/
export function getRecentlyViewedListFromCookie(slug, req, res) {
  let recentlyViewedVehicleArr = [];
  // const storageKeyName = "v1_recently_viewed_" + get_cookie("cityStateSlug");
  let storageKeyName = makeCookieStorageKey("v2_recently_viewed", slug);
  const list = getCookies({ req, res })?.[storageKeyName];

  if (typeof list !== "undefined") {
    if (list) {
      const decodedList = decodeURIComponent(list);
      const tempOfObj = JSON.parse(decodedList);
      recentlyViewedVehicleArr = [...tempOfObj];
    }
  }
  return recentlyViewedVehicleArr;
}

/*******************
  @purpose : Set brand and category slug in local storage
  @Parameter : {slug}
  @Author : INIC
  ******************/
export function setBrandCategoryListAsUserBehaviour(slug, flag) {
  let arrOfObj = [];
  let storageKeyName;
  if (flag != "category") {
    // storageKeyName = "brand_list_" + get_cookie("cityStateSlug");
    storageKeyName = makeLocalStorageKey("v2_brand_list");
  } else {
    // storageKeyName = "category_list_" + get_cookie("cityStateSlug");
    storageKeyName = makeLocalStorageKey("v2_category_list");
  }
  const list = localStorage.getItem(storageKeyName);
  if (typeof list !== "undefined") {
    if (list) {
      const tempOfObj = JSON.parse(list);
      arrOfObj = [...tempOfObj].reverse();
    }
  }
  arrOfObj.push(slug);
  const reverseArr = [...new Set(arrOfObj.reverse())];
  let str = JSON.stringify(reverseArr);
  localStorage.setItem(storageKeyName, str);
}

/*******************
  @purpose : Get brand and category slug in local storage
  @Parameter : {}
  @Author : INIC
  ******************/
export function getBrandCategoryListAsUserBehaviour(brandCategoryList, flag) {
  let storageKeyName;
  if (flag != "category") {
    // storageKeyName = "brand_list_" + get_cookie("cityStateSlug");
    storageKeyName = makeLocalStorageKey("v2_brand_list");
  } else {
    // storageKeyName = "category_list_" + get_cookie("cityStateSlug");
    storageKeyName = makeLocalStorageKey("v2_category_list");
  }
  const list = localStorage.getItem(storageKeyName);
  if (typeof list !== "undefined" && list) {
    const tempArr = JSON.parse(list);
    let matchArr = getMatchArr(tempArr, brandCategoryList);
    let unMatchArr = getUnmatchArr(tempArr, brandCategoryList);
    if (matchArr.length > 0 && unMatchArr.length > 0) {
      return matchArr.concat(unMatchArr);
    } else if (matchArr.length > 0) {
      return matchArr;
    } else {
      return unMatchArr;
    }
  } else {
    return brandCategoryList;
  }
}

export function getMatchArr(tempArr, list) {
  let matchArr = [];
  tempArr.forEach((value) => {
    list.forEach((row) => {
      if (value == row.slug) {
        matchArr.push(row);
      }
    });
  });
  return matchArr;
}

export function getUnmatchArr(tempArr, list) {
  let unMatchArr = [];

  list.forEach((row) => {
    let flag = false;
    tempArr.forEach((value) => {
      if (value == row.slug) {
        flag = true;
      }
    });
    if (!flag) {
      unMatchArr.push(row);
    }
  });
  return unMatchArr;
}

/*******************
  @purpose : Login/signup GA4 event
  @Parameter : {}
  @Author : INIC
  ******************/
export function loginSignUpGAEvent() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "login",
  });
}

/*******************
  @purpose : Google ads converstion page thank you page code
  @Parameter : {}
  @Author : INIC
  ******************/
export function thankYouPageGACP() {
  let decId = get_cookie("decId") ? get_cookie("decId") : "";
  let total = get_cookie("total") ? get_cookie("total") : "";
  let selectedCar = get_cookie("selectedCar") ? get_cookie("selectedCar") : "";

  if (APP_ENVIRONMENT === "production" && decId && total) {
    // GA3 tracking code
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-945888477";
    // script.async = true;
    document.body.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "AW-945888477");
    gtag("event", "conversion", {
      send_to: "AW-945888477/Apq6CMr51-YDEN25hMMD",
      value: total,
      currency: "USD",
      transaction_id: decId,
    });

    // GA4 traking code
    // GA4TrackingCode(total, decId);

    GA4PurchaseEvent(total, decId, selectedCar);
  }
}

/*******************
  @purpose : Google ads purchase code of thank you page code
  @Parameter : {total,decId}
  @Author : INIC
  ******************/
export function GA4PurchaseEvent(total, decId, selectedCar) {
  const script = document.createElement("script");
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-9H9ZPGNL39";
  // script.async = true;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || []; //initialising data layer
  window.dataLayer.push({
    event: "purchase",
    data: {
      currency: "USD",
      transactionId: decId,
      value: total,
      selectedCar: selectedCar,
    },
  });
}

/*******************
  @purpose : Google ads purchase code of thank you page code
  @Parameter : {total,decId}
  @Author : INIC
  ******************/
export function GA4TrackingCode(total, decId) {
  const script = document.createElement("script");
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-9H9ZPGNL39";
  // script.async = true;
  document.body.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "G-9H9ZPGNL39");
  gtag("event", "purchase", {
    value: total,
    currency: "USD",
    transaction_id: decId,
  });
}

/*******************
  @purpose : Set subscriber in local storage as per location
  @Parameter : {}
  @Author : INIC
  ******************/
export function setSubscribeDataAsPerLocation() {
  const storageKeyName = makeLocalStorageKey("v2_subscriber");
  localStorage.setItem(storageKeyName, "yes");
}

/*******************
  @purpose : get subscriber in local storage as per location
  @Parameter : {}
  @Author : INIC
  ******************/
export function getSubscribeDataAsPerLocation() {
  const storageKeyName = makeLocalStorageKey("v2_subscriber");
  const str = localStorage.getItem(storageKeyName);
  if (str) {
    return false;
  } else {
    return true;
  }
}
/*******************
  @purpose : Make local in cookie as per location
  @Parameter : {}
  @Author : INIC
  ******************/
export function makeLocalStorageKey(str) {
  const url = new URL(window.location.href);
  let storageKeyName = str + "_la_ca";
  if (url.pathname != "/") {
    if (url.pathname.includes("/ca/")) {
      storageKeyName = str + "_la_ca";
    } else {
      storageKeyName = str + "_miami_fl";
    }
  }
  return storageKeyName;
}
export function makeCookieStorageKey(str, slug) {
  let storageKeyName = str + "_la_ca";
  if (slug) {
    if (slug === "ca") {
      storageKeyName = str + "_la_ca";
    } else if (slug === "fl") {
      storageKeyName = str + "_miami_fl";
    }
  }
  return storageKeyName;
}

/*******************
  @purpose : Make local in cookie as per location
  @Parameter : {}
  @Author : INIC
  ******************/
export function makeStorageKeyForCookie(str) {
  let storageKeyName = str + "_" + get_cookie("cityStateSlug");
  return storageKeyName;
}

export default function NewLineToBr({ children = "" }) {
  return children.split("\n").reduce(function (arr, line) {
    return arr.concat(line, <br />);
  }, []);
}

/*******************
  @purpose : Store last visited vehicle slug in local storage
  @Parameter : {slug}
  @Author : INIC
  ******************/
export function storeLastVisitedVehicleSlug(slug) {
  const storageKeyName = makeLocalStorageKey("v2_v_slug");
  localStorage.setItem(storageKeyName, slug);
}

/*******************
  @purpose : Get banner category class title position 
  @Parameter : {slug}
  @Author : INIC
  ******************/
export function getBannerCategoryClassOfTitlePosition(titlePosition) {
  let cName = "banner-content ";
  let pos = "position-1";
  switch (titlePosition) {
    case "top_center":
      pos = "position-1";
      break;

    case "above_center":
      pos = "position-2";
      break;

    case "center":
      pos = "position-3";
      break;

    case "below_center":
      pos = "position-4";
      break;

    case "bottom_center":
      pos = "position-5";
      break;

    case "year":
      pos = "position-3";
      break;
  }
  return cName + pos;
}
